// 肉集小助手
export const AssistID = 'BTCbifurouji'
// 上传宣传册默认账号
export const Account = 'dragontest'
// export const Account = 'lixiao'

// 发布解牛评论默认账号
export const CutsCommentAccount = 'dragontest'
// export const CutsCommentAccount = 'zhaoxi'

// 静态资源地址
// export const StaticResource = 'http://jason235.synology.me:10081/staticfiles/' // 测试环境
export const StaticResource = 'https://api.beeftochina.com.cn/StaticFiles/' // 正式环境
// export const StaticResource = 'http://192.168.10.113:5000/StaticFiles/' // 测试环境

// 下载地址
// export const DownloadFileAddr = 'http://jason235.synology.me:10081/api/SystemApi/' // 测试环境
export const DownloadFileAddr = 'https://api.beeftochina.com.cn/api/SystemApi/' // 正式环境



// WEBPACK FOOTER //
// ./src/utils/config.js